import React, { ChangeEvent, useEffect, useState } from 'react';
import { useAuth } from 'contexts/auth.context';

import {
  Box,
  SimpleGrid,
  Button,
  Card,
  Flex,
  FormControl,
  Icon,
  Text,
  Spinner,
  useToast,
  Divider,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  AlertDialog,
  useDisclosure,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Center,
  Badge,
} from '@chakra-ui/react';
import { MdGroupAdd, MdModeEdit, MdClose, MdDelete } from 'react-icons/md';
// import InputField from 'components/fields/InputField';
import {
  addcohorts,
  getcohorts,
  updatecohorts,
  checkCohorts,
  reomvecohorts,
} from 'utils/leaner/leaner';
import {  getAllCreator} from 'utils/creator/creator';
import {
  addLearner,
  getLearnerById,
  updateLearner,
  learnerStatus,
} from 'utils/leaner/leaner';
import { useNavigate } from 'react-router-dom';
import OnToast from 'components/alerts/toast';
import { SlOptionsVertical } from 'react-icons/sl';
import Popup from 'components/alerts/Popup';
import {
  creatPlanValidity,
  updatePlanValidity,
  getPlanTypeInCreator,
} from 'utils/planvalidity/planvalidity';
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import SelectField from 'components/fields/SelectFieldtwo';
import { getPlanName } from 'utils/plan/plan';
import { getPlanType } from 'utils/subscriptionPlans/subscriptionPlan';

import PlanImg from 'assets/img/users/Project2.png';
import { result } from 'lodash';
import {formatDateToISO, calculateValidityTo } from './helper';

// AddCoharts component
interface AddCohortsProps {
  setOpenCoharts: React.Dispatch<React.SetStateAction<boolean>>;
  onSaveSelectedValues: (selectedIds: number[]) => void;
  learnerId: number;
  fetchData: ()=>void;
  setEnableToast: (val:boolean)=>void;
  setToastStatus: (val:string)=>void;
  setMsg:(val:string)=>void;
}
interface planType {
  plId: string;
  plPlanName: string;
  plPlanType: string; // Add plPlanType property
  // other properties if any
}
interface Cohort {
  chId: number;
  chCohortsName: string;
}
interface OptionType {
  value: string;
  label: string;
}
type PlanType = {
  status: string,
  message: string,
  data: any[],
}

const planTypeInitValue : PlanType = {
    status: '',
    message: '',
    data: [],
}
const AddCoharts: React.FC<AddCohortsProps> = ({
  setOpenCoharts,
  onSaveSelectedValues,
  learnerId,
  fetchData,
  setEnableToast,
  setToastStatus,
  setMsg
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [plantype, setPlantype] = useState(planTypeInitValue);
  const { user, setUser } = useAuth();
  const toast = useToast();
  const [cohorts, setCohorts] = useState<Cohort[]>([]);
  const [selectedValues, setSelectedValues] = useState<number[]>([]);
  const [input, setInput] = useState<string>('');
  const [labelset, setLabel] = useState<string>('ADD');
  const [updateId, setupdateId] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAdding, setIsAdding] = useState<boolean>(false); // New state to track if adding
  // const [alert, setAlert] = useState(false);
  // const [msg, setMsg] = useState<string>('');
  // const [toastStatus, setToastStatus] = useState<string>('');
  const [fetchTrigger, setFetchTrigger] = useState(false);

  const [ApiplanData, setApiPlanData] = useState(null);
  const [planData, setPlanData] = useState(null);
  const [plan, setplan] = useState<planType[]>([]);
  // const [isOpenn, setIsOpen] = useState(true); 
  const [selected, setSelected] = useState({
    ctPlanId: '',
    phRenewalPlanId: '',
    phRenewalValidityDays: '',
  });
  const [selectedPlanTypeValues, setSelectedPlanTypeValues] = useState<
    string[]
  >([]);
  const [RenewalPlan, setRenewalPlan] = useState<boolean>(true);
  const [RenewalValidityDays, setRenewalValidityDays] = useState<boolean>(true);

  const mappedPlanOptions = Array.isArray(plan)
    ? plan.map((plan) => ({
        value: plan.plId, // Convert to string
        label: plan.plPlanName,
      }))
    : [];

  const [isConfirm, setIsConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState<number>();
  type FormData = {
    phCreatorId: number;
    ctPlanId: string;
    phRenewalPlanId: string;
    phRenewalValidityDays: string;
    phRenewalPlanValidityFrom: string;
    phRenewalPlanValidityTo: string;
  };
  const [formData, setFormData] = useState<FormData>({
    phCreatorId: learnerId,
    ctPlanId: '',
    phRenewalPlanId: '',
    phRenewalValidityDays: '',
    phRenewalPlanValidityFrom: '',
    phRenewalPlanValidityTo: '',
  });
  const [planTypeOptions, setPlanTypeOptions] = useState<OptionType[]>([]);
  const [refreshField, setRefreshField] = useState(false);
  const navigate = useNavigate();
  const fetchCohorts = async () => {
    try {
      const result = await getcohorts();
      if (result?.status === 'Success') {
        setCohorts(result?.data || []);
      } else {
        console.error('Error fetching cohorts:', result?.message);
      }
    } catch (error) {
      console.error('An error occurred while fetching cohorts:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchPlanNames = async () => {
      try {
        const plans = await getPlanName(); // Replace with your actual function to get plan names
        if (plans?.status !== 'Success')
          return console.log('getPlanNames Error:', plans?.message);
        setplan(plans.data);
       
      } catch (error) {
        console.error('Error fetching plan names:', error);
      }
    };

    fetchPlanNames();
    setRenewalPlan(!RenewalPlan);
    setRenewalValidityDays(!RenewalValidityDays);
  }, []); 
  // Em

  function validDataSet(obj: any) {
    const currentIndex = Object.keys(formData).indexOf(obj.name);
    const emptyKeys = Object.keys(formData).filter((key, index) => {
      const formDataKey = key as keyof FormData;
      return index < currentIndex && formData[formDataKey] === '';
    });

    Object.keys(formData).forEach((key) => {
      if (emptyKeys.includes('phRenewalPlanId')) {
        setRenewalPlan(true);
      } else {
        setRenewalPlan(false);
      }

      if (emptyKeys.includes('phRenewalValidityDays')) {
        setRenewalValidityDays(true);
      } else {
        setRenewalValidityDays(false);
      }
    });
  }
  const fetchPlanType = async (planId: string) => {
    try {
      const result = await getPlanType(planId);
      setPlantype(result);
    } catch (error) {
      console.error('An error occurred while fetching plan types:', error);
    }
  };
  const handleChangeplan = (selectedOption: OptionType | null) => {
    if (selectedOption) {
      const value = selectedOption ? selectedOption.value : '';
      setFormData({ ...formData, phRenewalPlanId: selectedOption?.value, phRenewalValidityDays: null });
      setPlantype(planTypeInitValue);
      fetchPlanType(selectedOption?.value || '');
      setRefreshField((prev) => !prev);
      validDataSet({ name: 'phRenewalPlanId', value: value });
    }
  };

const handleChangePlanType = (selectedOption: OptionType | null) => {
    const value = selectedOption ? selectedOption.value : '';
    
    setFormData({ ...formData, phRenewalValidityDays: value });
    validDataSet({ name: 'phRenewalValidityDays', value: value });
  };
  useEffect(() => {
    // Fetch plan type data when phRenewalPlanId changes
    if (formData.phRenewalPlanId) {
      fetchPlanType(formData.phRenewalPlanId);
    }
  }, [formData.phRenewalPlanId]);
  useEffect(() => {
    // Update plan type options when plantype data changes
    if (plantype.data) {
      const newPlanTypeOptions = plantype.data.map((pt) => ({
        value: `${pt.psPlanDuration}-${pt.psPlanType}`,
        label: `${pt.psPlanDuration}-${pt.psPlanType}`,
      }));
      setPlanTypeOptions(newPlanTypeOptions);
    }
  }, [plantype.data]);

  useEffect(() => {
    const fetchLearnerById = async () => {
      try {
        const results = await getPlanTypeInCreator(learnerId);
        if (results?.status === 'Success') {
          // setPlanData(results);
          setApiPlanData(results);
        } else {
          console.error('Error fetching learner:', results?.message);
        }
      } catch (error) {
        console.error('An error occurred while fetching learner:', error);
      }
    };

    if (learnerId) {
      fetchLearnerById();
    }
  }, [learnerId]);

  const fetchUpcomingPlanData = async () => {
    try {
      const results = await getPlanTypeInCreator(learnerId);
      if (results?.status === 'Success') {
        console.log("results", results)
        // setPlanData(results);
        setApiPlanData(results);
      } else {
        console.error('Error fetching learner:', results?.message);
      }
    } catch (error) {
      console.error('An error occurred while fetching learner:', error);
    }
  };

  function calculateNextPlanValidityStartDate( currentValidityTo: string,): number | null {
    const currentDate = new Date(currentValidityTo);
    if (isNaN(currentDate.getTime())) {
      // Handle invalid date format
      return null; // or some default value
    }

    // Add one day to the current plan's validity end date
    const nextStartDate = new Date(currentDate);
    nextStartDate.setDate(currentDate.getDate() + 1);
    return nextStartDate.getTime();
  }

  // useEffect(() => {
  //   // const fetchData = async () => {
  //   //   const result = await getAllCreator();
  //   //   if (result?.status !== 'Success') {
  //   //     console.log('getCreator Error:', result?.message);
  //   //   }
  //   // };

  //   if (fetchTrigger) {
  //     console.log("inside of trigger")
  //     fetchData();
  //   }
  // }, [fetchTrigger]);

  const handleSave = async (e: React.FormEvent) => {
    console.log("add***")
    fetchUpcomingPlanData();
    const startDate = new Date(); // Current date and time
    const pad = (num: number): string => num.toString().padStart(2, '0');
const currentPlanValidityTo = planData?.data?.phPlanValidityTo;
let newPlanstartDate :string | null= null;
let newPlanExpairyDate :string | null= null;
let formDataWithDates:any= null;

// const formatDateToISO = async (date : Date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
//   const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
//   return `${year}-${month}-${day}`;
// }

// async function calculateValidityTo(
//   validityDays: string,
//   formattedStartDate: any,
// ) {
//   const regexResult = validityDays.match(/(\d+)-(\w+)/);

//   if (!regexResult || regexResult.length !== 3) {
//     return null; // or some default value
//   }

//   const numericValue = parseInt(regexResult[1], 10);
//   const unit = regexResult[2].toLowerCase();

//   if (isNaN(numericValue) || numericValue <= 0) {
//     return null; // or some default value
//   }

//   const today = new Date();
//   const validityTo = new Date(formattedStartDate);

//   switch (unit) {
//     case 'day':
//     case 'days':
//       validityTo.setDate(validityTo.getDate() + numericValue);
//       break;
//     case 'month':
//     case 'months':
//       validityTo.setMonth(validityTo.getMonth() + numericValue);
//       break;
//     case 'year':
//     case 'years':
//       validityTo.setFullYear(validityTo.getFullYear() + numericValue);
//       break;
//     default:
//       return null; // or some default value
//   }

//   if (unit === 'months') {
//     validityTo.setDate(0); // Set to the last day of the current month
//   } else if (unit === 'years') {
//     validityTo.setMonth(11); // Set to December
//     validityTo.setDate(31); // Set to the last day of December
//   }

//   return validityTo;
// }
const updateAPICall = async(learnerId : number, datas:any)=>{
const validityResult = await updatePlanValidity(learnerId, datas);
if (validityResult?.status !== 'Success') {
  setMsg('Failed to create PlanValidity');
  setToastStatus('error');
  setEnableToast(true);
  // setAlert(true);
  return;
}
setToastStatus('success');
setMsg('Plan updated successfully..!');
setEnableToast(true);
// setAlert(true);
// fetchUpcomingPlanData();
setTimeout(()=>{
  fetchData();
},2000)
return;
}

const createAPICall = async(data:any)=>{
const validityResult = await creatPlanValidity(data);
if (validityResult?.status !== 'Success') {
  setMsg('Failed to Subscribe a Plan');
  setToastStatus('error');
  setEnableToast(true);
  // setAlert(true);
  return;
}
setToastStatus('success');
setMsg('Plan Subscribed successfully..!');
setEnableToast(true);
setTimeout(()=>{
  fetchData();
},2000);
return;
}

if(currentPlanValidityTo){
    const now = new Date();  
    const currentDate=await formatDateToISO(now);
    const currentDateObj = new Date(currentDate);
    const currentPlanValidityToObj = new Date(currentPlanValidityTo);
    // newPlanstartDate = await findActivePlan();
    
    if(currentDateObj <= currentPlanValidityToObj)
    {
      const incrementedDate = new Date(currentPlanValidityToObj);
      // Increment the date by one day
      incrementedDate.setDate(incrementedDate.getDate() + 1);
      newPlanstartDate = await formatDateToISO(incrementedDate);
    }

    formDataWithDates = {
      ...formData, 
      phRenewalPlanValidityFrom: newPlanstartDate,
      phRenewalPlanValidityTo: await formatDateToISO(await calculateValidityTo(
        formData.phRenewalValidityDays,
        newPlanstartDate,
      )),
    };
    setRenewalValidityDays(true);
    setRenewalPlan(true);
    let data = JSON.stringify(formDataWithDates);
    updateAPICall(learnerId, data);
}
else{
  const now = new Date();  
    const currentDate=await formatDateToISO(now);
    let data1 = {...ApiplanData.data};
    let activePlan = await findActivePlan(data1);
    if(activePlan?.ValidityDate && !isNaN(Number(activePlan?.ValidityDate)))  {
      console.log("activePlan",activePlan)
      console.log("activePlan-data1",data1)
    if(activePlan?.ValidityDate > currentDate) {
      
        let date = new Date(activePlan?.ValidityDate);
        // Increase the date by 1 day
        date.setDate(date.getDate() + 1);
  console.log("")
        // Format the date back to 'YYYY-MM-DD'
        newPlanstartDate = date.toISOString().split('T')[0];  
      
    }
  }
    else{
      newPlanstartDate = currentDate;
    }
  formDataWithDates = {
    ...formData,
    phPlanId: formData.phRenewalPlanId, 
    phPlanValidityFrom: newPlanstartDate,
    phPlanValidityTo: await formatDateToISO(await calculateValidityTo(
      formData.phRenewalValidityDays,
      newPlanstartDate,
    )),
    phRenewalValidityDays: null,
    phRenewalPlanId: null,
    phValidityDays: formData.phRenewalValidityDays,
    phCreatorId: learnerId,
    phRenewalPlanValidityFrom: null,
    phRenewalPlanValidityTo:null,
  };
    setRenewalValidityDays(false);
    setRenewalPlan(false);
    let data = JSON.stringify(formDataWithDates);
    createAPICall(data);
}
    // if (!formData['phRenewalPlanId']) {
    //   setRenewalPlan(true);
    // } else {
    //   setRenewalPlan(false);
    // }
  
    // if (!formData['phRenewalValidityDays']) {
    //   setRenewalValidityDays(true);
    // } else {
    //   setRenewalValidityDays(false);
    // }

    
    
  
    // Call fetchData after the plan validity update
    // await fetchData();
  
    setOpenCoharts(false);
    if (user.data.role === 'Admin') {
      navigate('/admin/superadmin/creator/');
      // window.location.reload();
    } else {
      // navigate('/admin/superadmin/dashboards');
      navigate('/admin/superadmin/game/home');
    }
      // Refresh the page
    // window.location.reload();
  };

  const getPlanNameById = (planId: string): string => {
    const foundPlan = plan.find((p: planType) => p.plId === planId);
    return foundPlan ? foundPlan.plPlanName : 'Unknown Plan';
  };
  const handleClose = () => {
    setOpenCoharts(false);
    navigate('/admin/superadmin/creator/');
  };

  const findActivePlan = async(data: any)=> {
  
    let Plandays = 'N/A';
    let Validitydays = 'N/A';
    let ValidityPlan = 'N/A';
    let ValidityDate = 'N/A';
    let validityDaysRemaining = 0;

const currentDate = new Date().getTime();

let validityEndDate = data.validityLogs ? new Date(data.phPlanValidityTo).getTime() : null;
const renewLogs = data?.renewalLogs;

let remaingingTime = validityEndDate - currentDate; // in milliseconds  

if((isNaN(remaingingTime)) || remaingingTime <= 0)
  {
    // console.log(" map  loop if")
    if(renewLogs?.length > 0)
    {
      for(let i=0; renewLogs && i < renewLogs?.length;i++)
      {
        const renewalPlanToDate = new Date(renewLogs[i].prPlanValidityTo).getTime();
      
        const remainingTimeToDate =  renewalPlanToDate - currentDate;
        if(remainingTimeToDate > 0 ){
          validityDaysRemaining = Math.ceil(remainingTimeToDate / (1000 * 60 * 60 * 24));
          Validitydays = `${validityDaysRemaining} Days left`;
          ValidityPlan = renewLogs[i]?.lmsplan?.plPlanName || 'N/A';
          ValidityDate = renewLogs[i]?.prPlanValidityTo || 'N/A';
          Plandays = renewLogs[i]?.prValidityDays || 'N/A';
          break;
        }
        else if(renewLogs?.length-1 === i){
          Validitydays = `Expired`;
          ValidityPlan = renewLogs[i]?.lmsplan?.plPlanName || 'N/A';
          ValidityDate = renewLogs[i]?.prPlanValidityTo || 'N/A';
          Plandays = renewLogs[i]?.prValidityDays || 'N/A';
        }   
      }
    }
    else{
      let remainingDays =Math.ceil(remaingingTime / (1000 * 60 * 60 * 24));
      Validitydays = remaingingTime > 0 ? `${remainingDays} ${remainingDays > 1 ? 'Days' : 'Day'} left` : `Expired`;
      ValidityPlan = data?.lmsplan?.plPlanName || 'N/A';
      ValidityDate = data?.phPlanValidityTo || 'N/A';
      Plandays = data?.phValidityDays || 'N/A';
    }
}
else if(!isNaN(remaingingTime)){
  // console.log(" map  loop else")
  // validityDaysRemaining = Math.ceil(remaingingTime / (1000 * 60 * 60 * 24));
  let remainingDays =Math.ceil(remaingingTime / (1000 * 60 * 60 * 24));
  Validitydays = remaingingTime > 0 ? `${remainingDays} ${remainingDays > 1 ? 'Days' : 'Day'} left` : `Expired`;
  ValidityPlan = data?.lmsplan?.plPlanName || 'N/A';
  ValidityDate = data?.phPlanValidityTo || 'N/A';
  Plandays = data?.phValidityDays || 'N/A';
}


return {
Validitydays: Validitydays,
ValidityPlan: ValidityPlan,
ValidityDate: ValidityDate,
Plandays: Plandays
};
}

const findUpcomingPlan = async (activePlan : any, data: any)=> {
if(data?.renewalLogs?.length ===0 ){
  return null; 
}
const currentDate = new Date().toISOString().split('T')[0];
const activePlanEndDate = new Date(activePlan.ValidityDate).toISOString().split('T')[0];

for (let i = 0; i < data.renewalLogs.length; i++) {
    const log = data.renewalLogs[i];
    const logStartDate = log.prPlanValidityFrom;
    const logEndDate = log.prPlanValidityTo;
    
    
    // Check if this log is a valid upcoming plan
    if (logStartDate > activePlanEndDate && logStartDate > currentDate && logEndDate > currentDate) {
        return {
          ValidityPlan: data.renewalLogs[i]?.lmsplan?.plPlanName,
          ValidityToDate: data.renewalLogs[i]?.prPlanValidityTo,
          ValidityFromDate: data.renewalLogs[i]?.prPlanValidityFrom,
          Plandays: data.renewalLogs[i].prValidityDays
         };
    }
}

return null; // No upcoming plan found
}

  useEffect(()=>{
const findCardObj=async()=>{
    let plan ={
      planName:'',
      validityDays:'',
      planValidityFrom:'',
      planValidityTo: '',
    }
// let activePlan = {...plan};
// let upcomingPlan = {...plan};



  let data = {...ApiplanData.data};
  let activePlan = await findActivePlan(data);
  let upcomingPlan = await findUpcomingPlan(activePlan, data);
  setPlanData({
    activePlan: {...activePlan},
    upcomingPlan: {...upcomingPlan},
  });
  }
  if(ApiplanData?.data)
  {
    findCardObj();
  }
},[ApiplanData])

console.log("********planData", planData);
  return (
    <>
      <Flex
        _before={{
          content: '""',
          background: '#1b1b1c4a',
          height: '100%',
          width: '100%',
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
        }}
      >
        <Card
          position="fixed"
          w={{ sm: '87%', md: '500px' }}
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          background="#fff"
          display="flex"
          alignItems="center"
          boxShadow="1px 2px 17px #42414556"
          p="20px"
          zIndex={9}
          borderRadius={'22px'}
        >
          <Flex justify="space-between" align="center" w="100%" pb={'10px'}>
            <Text fontSize={22}>Renew Plan</Text>

            <Text fontSize={25}>
              <Icon as={MdClose} cursor="pointer" onClick={handleClose} />
            </Text>
          </Flex>
          <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
            {planData?.activePlan && (
              <>
              <Box w={'100%'} display={'flex'}>
  <Box width={'100%'} borderRadius={'10px'} padding={'10px'}>
    <Text fontSize={16} fontWeight={700}>
      Active Plan
    </Text>
    <Text fontSize={14} mb={'10px'}>
      Expires on {planData.activePlan?.ValidityDate ?? 'N/A'}
    </Text>
    <Divider color={'grey'} mb={'10px'} />
    <Box display={'flex'} justifyContent={'space-between'}>
      <Box>
        <Text fontSize={17} fontWeight={600}>
          {/* {getPlanNameById(planData.data?.phPlanId) ?? 'Unknown Plan'} */}
          {planData.activePlan?.ValidityPlan}
        </Text>
        <Text fontSize={14}>
          Validity:{' '}
          {planData.activePlan?.Plandays
            ? planData.activePlan?.Plandays.replace(/-/g, ' ')
            : 'N/A'}
        </Text>
        {/* <Text fontSize={14}>
          Renews on {planData.upcomingPlan?.ValidityFromDate ?? 'N/A'}
        </Text> */}
      </Box>
    </Box>
  </Box>
</Box>

              </>
            )}
            
            <>
            {planData?.upcomingPlan?.ValidityPlan && (
              <Box
                w={'100%'}
                border="1px solid"
                backgroundImage="linear-gradient(to bottom, #7551FF, #3311db)"
                color="#ffffff"
                boxShadow="rgba(112, 144, 176, 0.08) 14px 17px 40px 4px"
                borderRadius="20px"
              >
                <Box
                  boxShadow={'1px 3px 16px #8080803b'}
                  borderRadius={'10px'}
                  width={'100%'}
                  padding={'10px'}
                >
                  <Text fontSize={16} fontWeight={700}>
                    Upcoming Plan
                  </Text>
                  
                    <>
                      <Text fontSize={14} mb={'10px'}>
                        Renews on {planData.upcomingPlan.ValidityFromDate}
                      </Text>
                      <Divider color={'grey'} mb={'10px'} />
                      <Box display={'flex'} justifyContent={'space-between'}>
                        <Box>
                          {/* {planData?.data?.phRenewalPlanId !== 0 && ( */}
                            <>
                              <Text fontSize={17} fontWeight={600}>
                                {/* {getPlanNameById(planData.data.phRenewalPlanId)} */}
                                {planData?.upcomingPlan?.ValidityPlan}
                              </Text>
                              <Text fontSize={14}>
                                Validity:{' '}
                                {planData.upcomingPlan.Plandays.replace(
                                  /-/g,
                                  ' ',
                                )}
                              </Text>
                            </>
                          {/* )} */}
                        </Box>

                        <Box></Box>
                      </Box>
                    </>
                  
                </Box>
              </Box>
              )}
            </>
          </Box>
          <>
            <Box
              width={'100%'}
              mb={'20px'}
              mt={'20px'}
              padding={'10px'}
              borderRadius={'10px'}
              boxShadow={'1px 3px 16px #8080803b'}
            >
              <Text fontSize={20} fontWeight={700} textAlign={'center'}>
                Renew Plan Validity
              </Text>
              <Box width={'100%'} mt={'20px'} padding={'10px'}>
                <SelectField
                  id="phRenewalPlanId"
                  isRequired={true}
                  label="Renew Plan"
                  placeholder="Select Plan"
                  name="phRenewalPlanId"
                  value={
                    mappedPlanOptions.find(
                      (option) => option.value === formData?.phRenewalPlanId,
                    ) || null
                  }
                  onChange={handleChangeplan}
                  options={mappedPlanOptions}
                  handleSeletAttr={RenewalPlan}
                  />

                <SelectField
                  id="phRenewalValidityDays"
                  name="phRenewalValidityDays"
                  label="Renew Plan Type"
                  isRequired={true}
                  options={plantype.data.map((pt) => ({
                    value: `${pt.psPlanDuration}-${pt.psPlanType}`,
                    label: `${pt.psPlanDuration}-${pt.psPlanType} `, // Adjust the label format as needed
                  }))}
                  // options={plantype.data.map((pt) => ({ value: pt.phPlanId, label: pt.phPlanId }))}
                  onChange={handleChangePlanType}
                  value={plantype.data.find(
                    (pt) =>
                      pt.phRenewalPlanId === selected.phRenewalValidityDays,
                  )}
                  handleSeletAttr={RenewalValidityDays}
                  // value={selectedPlanType}
                  // isDisabled={!!id}
                />
              </Box>
              <Box w={'100%'} display={'flex'} justifyContent={'flex-end'}>
                <Button
                  _hover={{ backgroundColor: 'none' }}
                  onClick={handleSave}
                  bg={'linear-gradient(to bottom, #7551ff, #3311db)'}
                  color="#fff"
                  borderRadius={'none'}
                  width={'100%'}
                >
                  {labelset}
                </Button>
              </Box>
            </Box>
          </>
        </Card>
      </Flex>
    </>
  );
};

export default AddCoharts;
